import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { NSP_CORE } from '@xingternal/malt-constants';
import testable from '@xingternal/malt-util/testable';

import styles from './ViewWrapper.css';

const TestableDiv = testable(NSP_CORE, 'div');

const ViewWrapper = ({
  children,
  className,
  contentClassName,
  Footer,
  Header,
  testId,
  preventPropagation,
  stopPropagation,
  ...props
}) => {
  return (
    <TestableDiv
      className={styles.wrapper}
      testId={testId}
      onClick={preventPropagation ? stopPropagation : null}
      {...props}
    >
      {Header}
      <div className={classNames(styles.page, className)}>
        <div className={contentClassName}>
          <main id="content">{children}</main>
        </div>
      </div>
      {Footer}
    </TestableDiv>
  );
};

ViewWrapper.defaultProps = {
  stopPropagation: (e) => e.stopPropagation(),
};

ViewWrapper.displayName = 'ViewWrapper';

ViewWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  Footer: PropTypes.node,
  Header: PropTypes.node,
  testId: PropTypes.string,
  preventPropagation: PropTypes.bool,
  stopPropagation: PropTypes.func,
};

export { ViewWrapper };
